// extracted by mini-css-extract-plugin
module.exports = {"articleLinks":"styles_articleLinks__piQSB","title":"styles_title__EAeEJ","list":"styles_list__fKc2A","link":"styles_link__TN5dK"};